import React from "react";

export const CrossReactionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path d="M2.28033 1.21967C1.98744 0.926777 1.51256 0.926777 1.21967 1.21967C0.926777 1.51256 0.926777 1.98744 1.21967 2.28033L4.93934 6L1.21967 9.71967C0.926777 10.0126 0.926777 10.4874 1.21967 10.7803C1.51256 11.0732 1.98744 11.0732 2.28033 10.7803L6 7.06066L9.71967 10.7803C10.0126 11.0732 10.4874 11.0732 10.7803 10.7803C11.0732 10.4874 11.0732 10.0126 10.7803 9.71967L7.06066 6L10.7803 2.28033C11.0732 1.98744 11.0732 1.51256 10.7803 1.21967C10.4874 0.926777 10.0126 0.926777 9.71967 1.21967L6 4.93934L2.28033 1.21967Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
  </svg>
);
